import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import * as React from 'react';
import * as cx from 'classnames';

import { IControlButtonProps } from './types';
import { SIZE_TO_CLASS } from './constants';

import * as styles from './styles.css';

export function ControlButton({
  children,
  size = 'M',
  rounded,
  active,
  className,
  tooltip,
  ...sharedProps
}: IControlButtonProps) {
  const classNames = cx(
    styles['container'],
    SIZE_TO_CLASS[size],
    {
      [styles['active']]: active,
      [styles['rounded']]: rounded,
    },
    className,
  );

  if (!tooltip) {
    return (
      <button type="button" {...sharedProps} className={classNames}>
        {children}
      </button>
    );
  }

  return (
    <TooltipDesktop placement="left" theme="black" title={tooltip}>
      <button type="button" {...sharedProps} className={classNames}>
        {children}
      </button>
    </TooltipDesktop>
  );
}
